import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIconWrapperComponent } from '../icons/ng-icon-wrapper/ng-icon-wrapper.component';


@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    imports: [NgIconWrapperComponent, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
  @Input() variant: 'alert' | 'notification' = 'alert';
  @Input() heading: string = '';
  @Input() subheading: string | null = null;
  @Input() linkText: string | null = null;
  @Input() linkTarget: string | null = null;
}
